/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import classes from "../orders/orders.module.css";
import OrderTable from "../orders/orderTable";
import Input from "../../../component/inputpm";
import Loader from "../../../component/loader";
import ResendDialog from "../order/resendDialog";
import IconButton from "@mui/material/IconButton";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import moment from "moment";
import Paper from "@mui/material/Paper";
import Breadcrumb from "../../../component/breadcrumb";
import Tooltip from "@mui/material/Tooltip";
import { SearchIcon, ClearIcon } from "../../../component/icons/icons";
import { withTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { withNavigation } from "../../../helper/withNavigation";
import dateFormat from "dateformat";

// Manage order page class
class StatOrders extends Component {
  // Declare property values that belongs to the component
  state = {
    orders: [],
    orderId: "",
    customerName: "",
    customerBAN: "",
    orderStatus: "",
    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    totalOrderCount: 0,
    loading: true,
    actionOrderId: "",
    isMailDialog: false,
    sortBy: "orderDate",
    sortOrder: "DESC",
    controls: false,
    tenant: "",

    // Order status list
    statusList: [],
    bread: [
      { title: this.props.t("ORDER_STATISTICS"), url: "/stats" },
      {
        title:
          this.props.providerType === "SALES_CHNL_PROVIDER"
            ? this.props.t("ORDERS")
            : this.props.t("FULFILMENT_REQUEST"),
        url: "orderReport",
      },
    ],
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_ORDER_STATUSES/endpoint`,
      {},
    )
      .then((res) => {
        let list = res.data;
        // let all = {
        //     name: 'All Orders',
        //     value: 'All Orders'
        // }
        // list.unshift(all)
        this.setState({
          statusList: res.data,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
    var statsState = this.props.router.location.state;
    if (statsState && statsState.orderStatus) {
      this.setState(
        {
          ...this.state,
          ...statsState,
        },
        () => {
          this.getOrders();
        },
      );
    } else {
      this.props.router.navigate("/stats");
    }
  }

  // Fetch orders list
  getOrders = () => {
    this.setState({
      loading: true,
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };

    BusApiCall(
      "GET",
      `${constants.busV4Url}/orders?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&orderId=${this.state.orderId}&orderStatus=${encodeURIComponent(this.state.orderStatus)}&customerName=${this.state.customerName}&customerBan=${this.state.customerBAN}&from=${encodeURIComponent(this.state.from)}&to=${encodeURIComponent(this.state.to)}`,
      {},
      pageOptions,
    )
      .then((res) => {
        let data = res.data;
        if (data.length > 0) {
          for (let item of data) {
            item.accountName = item.customer.companyName;
            item.ban = item.customer.ban;
            // Check whether the order is auto-activated or not
            for (let userItem of item.userData) {
              if (userItem.name === "autoActivatable") {
                item.autoActivatable = userItem.value;
              }
            }
          }
          this.setState({
            orders: data,
            totalOrderCount: +res.headers["x-total-count"],
            loading: false,
            showLoading: false,
          });
        } else {
          this.setState({
            orders: [],
            totalOrderCount: 0,
            loading: false,
            showLoading: false,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  // Update state data on input change
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Open resend confirmation email modal
  openResendDialog = (orderId) => {
    this.setState({
      isMailDialog: true,
      actionOrderId: orderId,
    });
  };

  // Change page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Close confirmation email dialog
  closeMailDialog = () => {
    this.setState({
      isMailDialog: false,
      actionOrderId: "",
    });
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getOrders();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getOrders();
        },
      );
    }
  };

  // Search/Filter orders
  filterOrderTable = () => {
    this.setState(
      {
        page: 1,
        startRecord: 1,
        orderId: this.state.orderId,
        customerName: this.state.customerName,
        customerBAN: this.state.customerBAN,
        orderStatus: this.state.orderStatus,
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Clear all search filters
  clearOrderTableSearch = () => {
    this.setState(
      {
        orderId: "",
        customerName: "",
        customerBAN: "",
        // orderStatus: "",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getOrders();
      },
    );
  };

  // Search orders on press enter key
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterOrderTable();
    }
  };

  // Render order view
  render() {
    const t = this.props.t;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main>
          <Paper className="tablePaper" elevation={0}>
            {/* Search filters start */}
            <div className={classes.searchOuterDiv}>
              <div className={classes.searchInputDiv}>
                <Input
                  placeholder={t("ORDER_ID")}
                  value={this.state.orderId}
                  name={"orderId"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div className={classes.searchInputDiv}>
                <Input
                  placeholder={t("CUSTOMER_NAME")}
                  value={this.state.customerName}
                  name={"customerName"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              {this.props.providerType === "SALES_CHNL_PROVIDER" && (
                <div className={classes.searchInputDiv}>
                  <Input
                    placeholder={t("CUSTOMER_BAN")}
                    value={this.state.customerBAN}
                    name={"customerBAN"}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    divClass={classes.inputClass}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                  />
                </div>
              )}
              {/* <div className={classes.searchInputDiv}>
                            <Select
                                selectClass={classes.inputClass, classes.statusSelectBg}
                                name={'orderStatus'}
                                selected={this.state.orderStatus}
                                options={this.state.statusList}
                                optionLabel={(a) => a.name}
                                value={(a) => a.value}
                                onChange={(e) => { this.onChange(e) }}
                                onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                                size={'small'}
                                variant={'outlined'}
                            />
                        </div> */}
              {/* <div className={classes.searchOrderLabelOuter}>
                                <div className={classes.searchOrderLabelInner}> */}
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                {/* <IconButton onClick={this.filterOrderTable}>
                                    <SearchIcon />
                                </IconButton>
                                <IconButton onClick={this.clearOrderTableSearch}>
                                    <ClearIcon />
                                </IconButton> */}
                <Tooltip title={t("SEARCH")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.filterOrderTable}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
                <Tooltip title={t("CLEAR")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.clearOrderTableSearch}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </div>
              {/* </div> */}
            </div>
            {/* Search filters end */}

            {/* Order table component */}
            <OrderTable
              orderId={this.state.orderId}
              customerName={this.state.customerName}
              customerBAN={this.state.customerBAN}
              orders={this.state.orders}
              openResendDialog={this.openResendDialog}
              rowsPerPage={this.state.rowsPerPage}
              totalOrderCount={this.state.totalOrderCount}
              page={this.state.page}
              sortBy={this.state.sortBy}
              sortOrder={this.state.sortOrder}
              updateSorting={this.updateSorting}
              handleChangePage={this.handleChangePage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              controls={this.state.controls}
              userPerms={this.props.userPerms}
            />
          </Paper>
          {/* Resend confirmation dialog component */}
          <ResendDialog
            isOpen={this.state.isMailDialog}
            close={this.closeMailDialog}
            orderId={this.state.actionOrderId}
          />
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    providerType: state.auth.providerType,
    userPerms: state.auth.userPerms,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(StatOrders)));
